import React from 'react'
import BoldText from './styled-components/BoldText'

const EmailText = (props) => {
  return (
    <BoldText data-email-address-text>
      {props.email.length > 32
        ? `${props.email.split('@')[0]}\n@${props.email.split('@')[1]}`
        : props.email}
    </BoldText>
  )
}

export default EmailText
